export default "__VITE_ASSET__DfjQJHF1__"